import { render } from "./view_image_component.vue?vue&type=template&id=c8c14b06&scoped=true"
import script from "./view_image_component.vue?vue&type=script&lang=js"
export * from "./view_image_component.vue?vue&type=script&lang=js"

import "./view_image_component.vue?vue&type=style&index=0&id=c8c14b06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c8c14b06"

export default script